<div class="row rounded-card" id="settings-machine-clients">
  <div class="flex flex-wrap justify-between items-end mb-4" id="setting-view-header-wr">
    <div class="flex flex-col">
      <h2 data-testid="machine-client-title">{{ 'SYSTEM_SETTINGS.MODULES.MACHINE_CLIENTS_SETTINGS_TITLE' | translate }}</h2>
      <span class="text-base">{{ 'SYSTEM_SETTINGS.MODULES.MACHINE_CLIENTS_SETTINGS_SUBTITLE' | translate }}</span>
    </div>

    <div class="flex items-center gap-2">
      <button data-testid="add-machine-client-btn" class="btn primary-btn" (click)="displayCreateMachineClientModalbox()">
        Add machine client
      </button>
    </div>
  </div>

  <hr class="mb-1 mt-2 border-t">

  <section>
    <div class="col-12 mt-4">
      <p-table data-testid="machine-clients-table" [columns]="tableColumns" [value]="data" (onLazyLoad)="customSort($event)" [lazy]="true" [customSort]="true">

        <ng-template #header let-columns>
          <tr>
            @for (col of columns; track col; let colIndex = $index) {
              <th [pSortableColumn]="col.field">
                @if (colIndex !== columns.length - 1) {
                  <div class="header-wr">
                    <span [attr.data-testid]="'machine-client-table-header-' + colIndex" class="col-name">
                      {{ ('TABLE.HEADER.' + col.header) | translate }}
                    </span>
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  </div>
                } @else {
                  <span data-testid="machine-client-table-header-actions" class="col-name">
                    {{ col.field }}
                  </span>
                }
              </th>
            }
          </tr>

          <tr>
            @for (col of columns; track col; let colIndex = $index) {
              <th [attr.id]="col.field">
                @if (colIndex !== columns.length - 1) {
                  <app-table-filter
                    [dataTestId]="'filter-' + col.field"
                    [filterType]="col.filter"
                    [placeHolder]="'TABLE.FILTER.' + col.header"
                    [filterData]="col.filterData"
                    (onFilter)="filterEvent(col.filterField ?? col.field, $event, col.operator)">
                  </app-table-filter>
                }
              </th>
            }
          </tr>
        </ng-template>

        <ng-template #body let-rowData let-columns="columns" let-i="rowIndex">
          <tr [attr.data-id]="rowData.id">
            @for (col of columns; track col; let colIndex = $index) {
            <td [ngClass]="{ 'actions-col': colIndex === columns.length - 1 }">
              @if (colIndex !== columns.length - 1) {
              <span class="p-column-title">
                {{ ('TABLE.HEADER.' + col.header) | translate }}:
              </span>

              <span [attr.data-testid]="'machine-client-cell-' + colIndex + '-' + i">
                {{ tableSettingService.getColumnValue(rowData, col) | defaultValue }}
              </span>
              } @else {
              <div class="actions gap-2 flex justify-center">
                <button type="button" pTooltip="View" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-edit" (click)="onViewMachineClient($event, rowData)" [attr.data-testid]="'edit-machine-client-' + i">
                  <span class="btn-label">Edit</span>
                </button>

                @if (rowData.isActive) {
                  <button type="button" pTooltip="Revoke" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-deactivate-dg" (click)="onRevokeMachineClient($event, rowData.id)" [attr.data-testid]="'revoke-machine-client-' + i">
                    <span class="btn-label">Revoke</span>
                  </button>
                }

                @if (!rowData.isActive) {
                  <button type="button" pTooltip="Reactivate" tooltipPosition="top"
                    class="btn-icon-only ui-btn-view btn-icon icon-activate-dg"
                    (click)="onReactivateMachineClient($event, rowData.id)" [attr.data-testid]="'reactivate-machine-client-' + i">
                    <span class="btn-label">Reactivate</span>
                  </button>
                }

                <button type="button" pTooltip="Remove" tooltipPosition="top"
                  class="btn-icon-only ui-btn-view btn-icon icon-delete" (click)="onRemoveMachineClient($event, rowData)" [attr.data-testid]="'remove-machine-client-' + i">
                  <span class="btn-label">Remove</span>
                </button>
              </div>
              }
            </td>
            }
          </tr>
        </ng-template>

        <ng-template #emptymessage>
          <tr>
            <td [attr.colspan]="tableColumns?.length ?? 0">No machine clients set yet.</td>
          </tr>
        </ng-template>
      </p-table>

      <app-custom-paginator
        data-testid="machine-client-paginator"
        [pageNumber]="paginatorPageNumber"
        [rows]="pageSize"
        [totalRecords]="page?.totalCount ?? 0"
        [rowsPerPageOptions]="[10, 20, 30]"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
        [disabled]="(page?.totalCount ?? 0) === 0"
        [alwaysShow]="true"
        [showFirstLastIcon]="true"
        [showPageLinks]="true"
        [showPageSizeSelector]="true"
        (onPageChange)="onPaginatorChange($event)">
      </app-custom-paginator>
    </div>
  </section>
</div>

<!-- Modalbox: Create machine client -->
<p-dialog [(visible)]="showCreateMachineClientModal" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="true" [dismissableMask]="true" [header]="'New machine client'" [styleClass]="'overflow-y-visible'">

  <form class="mt-0" [formGroup]="machineClientForm">
    <div class="row">
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3">
        <label class="block text-sm">
          Name<i class="icon-required-field"></i>
        </label>

        <input data-testid="create-machine-client-name" type="text" formControlName="name" autocomplete="off" />
        @if (
          machineClientForm.get('name')?.invalid &&
          machineClientForm.get('name')?.touched
        ) {
          <small data-testid="machine-client-name-mandatory" class="p-error">
            {{ 'FORMS.MANDATORY_FIELD' | translate }}
          </small>
        }
      </div>

      <div class="field-wr flex flex-col col-12 col-md-6 mb-3 mt-1">
        <label class="block text-sm">
          Role<i class="icon-required-field"></i>
        </label>

        <app-custom-dropdown
          data-testid="create-machine-client-role"
          [placeholder]="'USER_UPDATE.SELECT_A_ROLE' | translate"
          optionLabel="text"
          optionValue="id"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="combosData['roles'].rowsPerPageOption || 5"
          [totalCount]="combosData['roles'].totalRecords"
          [totalPages]="getComboTotalPages('roles')"
          [options]="combosData['roles'].list"
          formControlName="roleId"
          (onLazyLoad)="onLazyLoadComboData('roles', $event)">
        </app-custom-dropdown>
        @if (
          machineClientForm.get('roleId')?.invalid &&
          machineClientForm.get('roleId')?.touched
        ) {
          <small data-testid="machine-client-role-mandatory" class="p-error">
            {{ 'FORMS.MANDATORY_FIELD' | translate }}
          </small>
        }
      </div>
    </div>
  </form>

  <ng-template #footer>
    <button type="button" class="btn outline-btn" (click)="cancelCreateMachineClient()">Cancel</button>
    <button type="button" class="btn primary-btn" [disabled]="machineClientForm.invalid" (click)="createMachineClient()"> Create machine client</button>
  </ng-template>
</p-dialog>

<!-- Modalbox: Update machine client -->
<p-dialog [(visible)]="showViewMachineClientModal" [modal]="true" [blockScroll]="true"[draggable]="false" [resizable]="false" [closable]="true" [dismissableMask]="true" [header]="'Update machine client'" [styleClass]="'overflow-y-visible'">

  <form class="mt-0" [formGroup]="updateMachineClientForm">
    <div class="row">
      <div class="field-wr flex flex-col col-12 col-md-6 mb-3">
        <label class="block text-sm">
          Name<i class="icon-required-field"></i>
        </label>

        <input data-testid="update-machine-client-name" type="text" formControlName="name" autocomplete="off" />

        @if (
          updateMachineClientForm.get('name')?.invalid &&
          updateMachineClientForm.get('name')?.touched
        ) {
          <small data-testid="update-machine-client-name-mandatory" class="p-error">
            {{ 'FORMS.MANDATORY_FIELD' | translate }}
          </small>
        }
      </div>

      <div class="field-wr flex flex-col col-12 col-md-6 mb-3">
        <label class="block text-sm">
          Role<i class="icon-required-field"></i>
        </label>

        <app-custom-dropdown data-testid="update-machine-client-role"
          [placeholder]="'USER_UPDATE.SELECT_A_ROLE' | translate"
          optionLabel="text"
          optionValue="id"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="combosData['roles'].rowsPerPageOption || 5"
          [totalCount]="combosData['roles'].totalRecords"
          [totalPages]="getComboTotalPages('roles')" [options]="combosData['roles'].list" formControlName="roleId"
          (onLazyLoad)="onLazyLoadComboData('roles', $event)">
        </app-custom-dropdown>

        @if (
          updateMachineClientForm.get('roleId')?.invalid &&
          updateMachineClientForm.get('roleId')?.touched
        ) {
          <small data-testid="update-machine-client-role-mandatory" class="p-error">
            {{ 'FORMS.MANDATORY_FIELD' | translate }}
          </small>
        }
      </div>
    </div>

    <div class="row">
      <div class="field-wr flex flex-col col-12 col-md-12 col-lg-12 col-xxl-12 mb-3 disabled">
        <label class="block text-sm">Client ID</label>
        <input data-testid="machine-clientid" type="text" [value]="selectedMachineClientId"
          autocomplete="off" disabled />
      </div>

      <div class="field-wr flex flex-col col-12 col-md-6 col-lg-8 col-xxl-8 mb-3 disabled">
        <label class="block text-sm">Secret key</label>
        <input data-testid="machine-client-secret-key" [type]="showSecretKey ? 'text' : 'password'" [value]="secretKey" autocomplete="off" disabled />
      </div>

      <div class="field-wr flex flex-col col-12 col-md-6 col-lg-4 col-xxl-4 mb-3">
        <div class="flex gap-2 flex-wrap py-2 mt-5">
          <button type="button" class="btn text-btn" [disabled]="!secretKey" (click)="toggleSecretKeyVisibility()">{{ showSecretKey ? 'Hide key' : 'View key' }}</button>

          @if (showSecretKey) {
            <button type="button" class="copy-btn" [disabled]="!secretKey" (click)="copySecretKey()">
              {{ secretKeyCopied ? 'Copied!' : 'Copy' }}
            </button>
          }
        </div>
      </div>
    </div>
  </form>

  <ng-template #footer>
    <button type="button" class="btn outline-btn" (click)="cancelViewMachineClient()">Cancel</button>
    <button type="button" class="btn primary-btn" [disabled]="updateMachineClientForm.invalid" (click)="saveMachineClient()">Update machine client</button>
  </ng-template>
</p-dialog>


<!-- Modalbox: delete machine client -->
<p-dialog [(visible)]="showDeleteMachineClientModal" [header]="'Delete machine client'" [modal]="true" [blockScroll]="true"[draggable]="false" [resizable]="false">
  <section class="row">
    <div class="col-12">
      <p class="pb-3">Are you sure you want to delete <strong>"{{ selectedMachineClientName }}"</strong> machine client?</p>
    </div>
  </section>
  <ng-template #footer>
    <button type="button" class="btn outline-btn" (click)="cancelDeleteMachineClient()">Cancel</button>
    <button type="button" class="btn primary-btn" (click)="deleteMachineClient()">Confirm</button>
  </ng-template>
</p-dialog>
